import React, { FC } from 'react';

import clsx from 'clsx';

import { DotsVerticalIcon } from '@components/icons';

import styles from './CategoryFiltersDrawerButton.module.scss';

export type CategoryFiltersDrawerButtonProps = {
    isActive: boolean;
    onClick(): void;
    className?: string;
};

export const CategoryFiltersDrawerButton: FC<CategoryFiltersDrawerButtonProps> = (props) => {
    const { isActive, onClick, className } = props;

    return (
        <button
            type="button"
            onClick={onClick}
            className={clsx(styles.root, isActive && styles.isActive, className)}
        >
            Фильтры
            <DotsVerticalIcon className={styles.dropdownIcon} />
        </button>
    );
};
